import React from 'react'
import { Icon } from './ShieldMoney.elements'

type Props = {
  className?: string
}

export const ShieldMoneyIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 49 49"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M9.62 14.462v11.104c0 4.22 2.136 8.153 5.677 10.45l9.188 5.958 9.188-5.958a12.455 12.455 0 005.678-10.45V14.462L24.485 7.87 9.62 14.462z" stroke="#1A1C1F" strokeWidth="1.245"/>
    <path d="M6.121 12.168v13.737a15 15 0 006.88 12.612l11.484 7.394 11.484-7.394a15 15 0 006.88-12.612V12.168L24.485 4.082 6.121 12.168z" stroke="#1A1C1F" strokeWidth="1.245"/>
    <rect x="16.894" y="16.894" width="16.245" height="16.245" rx="8.122" stroke="#4CA9ED" strokeWidth="1.245" strokeLinejoin="round"/>
    <path d="M27.665 22.794s-1.044-1.044-2.61-1.044c-2.088 0-3.132 2.61 0 3.132 2.773.462 2.61 2.61 1.044 3.132-1.253.418-2.958-.522-3.654-1.044M25.055 21.75v-2.61M25.055 30.626v-2.61" stroke="#4CA9ED" strokeWidth="1.337"/>
  </Icon>
)
